export const TRAINING_RATING_HOUSES = [
  {
    id: "cottage-0-500",
    label: "0 - 500",
    ratingFrom: 0,
    ratingTo: 500,
    position: { left: 8, top: 58, width: 25, height: 14 },
  },
  {
    id: "cabin-500-1000",
    label: "500 - 1000",
    ratingFrom: 500,
    ratingTo: 1000,
    position: { left: 9, top: 40, width: 22, height: 12 },
  },
  {
    id: "house-1000-1500",
    label: "1000 - 1500",
    ratingFrom: 1000,
    ratingTo: 1500,
    position: { left: 14, top: 25, width: 20, height: 11 },
  },
  {
    id: "villa-1500-2000",
    label: "1500 - 2000",
    ratingFrom: 1500,
    ratingTo: 2000,
    position: { left: 55, top: 56, width: 23, height: 11 },
  },
  {
    id: "manor-2000-2500",
    label: "2000 - 2500",
    ratingFrom: 2000,
    ratingTo: 2500,
    position: { left: 53, top: 38, width: 25, height: 11 },
  },
  {
    id: "estate-2500-3000",
    label: "2500 - 3000",
    ratingFrom: 2500,
    ratingTo: 3000,
    position: { left: 54, top: 22, width: 26, height: 11 },
  },
  {
    id: "castle-3000-plus",
    label: "3000+",
    ratingFrom: 3000,
    ratingTo: Number.POSITIVE_INFINITY,
    position: { left: 31, top: 2.5, width: 38, height: 18 },
  },
];

export function normalizeTrainingRating(value) {
  if (value === null || value === undefined || value === "") return null;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue >= 0 ? numericValue : null;
}

export function findTrainingHouseById(houseId) {
  if (!houseId) {
    return null;
  }

  return TRAINING_RATING_HOUSES.find((house) => house.id === houseId) || null;
}

export function findTrainingHouseByRange(ratingFrom, ratingTo) {
  return (
    TRAINING_RATING_HOUSES.find((house) => {
      const sameLowerBound = house.ratingFrom === ratingFrom;
      const sameUpperBound =
        (!Number.isFinite(house.ratingTo) && !Number.isFinite(ratingTo)) ||
        house.ratingTo === ratingTo;
      return sameLowerBound && sameUpperBound;
    }) || null
  );
}

export function findTrainingHouseByRating(rating) {
  const normalizedRating = normalizeTrainingRating(rating);

  if (normalizedRating === null) {
    return TRAINING_RATING_HOUSES[0];
  }

  return (
    TRAINING_RATING_HOUSES.find(
      (house) =>
        normalizedRating >= house.ratingFrom &&
        normalizedRating < house.ratingTo,
    ) || TRAINING_RATING_HOUSES[TRAINING_RATING_HOUSES.length - 1]
  );
}

export function isTrainingHouseOutgrown(rating, house) {
  const normalizedRating = normalizeTrainingRating(rating);

  if (normalizedRating === null || !house || !Number.isFinite(house.ratingTo)) {
    return false;
  }

  return normalizedRating > house.ratingTo;
}

export function isTrainingHouseUndershot(rating, house) {
  const normalizedRating = normalizeTrainingRating(rating);

  if (normalizedRating === null || !house) {
    return false;
  }

  return normalizedRating < house.ratingFrom;
}

export function formatTrainingHouseRange(house) {
  if (!house) {
    return "";
  }

  return Number.isFinite(house.ratingTo)
    ? `${house.ratingFrom} - ${house.ratingTo}`
    : `${house.ratingFrom}+`;
}

export function buildTrainingHouseQuery(house) {
  const params = new URLSearchParams();
  params.set("entryMap", "1");
  params.set("house", house.id);
  params.set("ratingFrom", String(house.ratingFrom));

  if (Number.isFinite(house.ratingTo)) {
    params.set("ratingTo", String(house.ratingTo));
  }

  return params.toString();
}


// The React castle IDs are labels for the map; Azure's Python API uses these
// legacy window identifiers. Never send a castle slug as a backend house ID.
const BACKEND_HOUSE_IDS = {
  "cottage-0-500": "0_500",
  "cabin-500-1000": "500_1000",
  "house-1000-1500": "1000_1500",
  "villa-1500-2000": "1500_2000",
  "manor-2000-2500": "2000_2500",
  "estate-2500-3000": "2500_3000",
  "castle-3000-plus": "3000_plus",
};

export function backendTrainingHouseId(house) {
  return house ? BACKEND_HOUSE_IDS[house.id] || null : null;
}

// Hood's automatic training always enters the house matching the player's
// present rating. A stale/old manually selected map house must not override it.
export function resolveAdaptiveTrainingHouse(requestedHouse, currentRating) {
  if (normalizeTrainingRating(currentRating) === null) return requestedHouse || null;
  return findTrainingHouseByRating(currentRating);
}
